import { useGraphQLQuery } from '@betterment/graphql';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { FourOhOneKContributionOverviewCard } from './FourOhOneKContributionOverviewCard/FourOhOneKContributionOverviewCard';
import { EnvelopeAccountTaxationTypesDocument } from './graphql/query.envelopeAccountTaxationTypes.generated';

import { LegalAccountTaxationType } from '../../../graphql/schema';
import { ENVELOPE_ACCOUNT_MANAGED_TYPE } from '../../../Shared/constants';

export const FourOhOneKContributionsCard: React.FC = () => {
  const householdId = useRequiredParam('householdId');
  const accountId = useRequiredParam('accountId');
  const { data, loading } = useGraphQLQuery(EnvelopeAccountTaxationTypesDocument, { variables: { id: accountId } });

  if (!data || loading) return null;
  if (data.envelopeAccount.__typename !== ENVELOPE_ACCOUNT_MANAGED_TYPE) return null;

  const fourOhOneKTypes = new Set([LegalAccountTaxationType.Roth_401K, LegalAccountTaxationType.Traditional_401K]);
  const taxationTypes = data.envelopeAccount.subAccounts.map(sa => sa.legalAccount.taxationType);

  if (!taxationTypes.some(t => fourOhOneKTypes.has(t))) return null;

  return <FourOhOneKContributionOverviewCard householdId={householdId} accountId={accountId} />;
};
